import React from 'react';
import { Wrapper } from '../Wrapper';
import { LpBanner as RawLpBanner } from '../../../components/landingPage/LpBanner';
import { Image, ImageProps } from '../Image';
import { SanityObject, useLpRedirect } from '../../../lib/landingPage';
import { isAbsoluteUrl } from '../../../lib';

export type LpBannerProps = {
    href: string;
    newTab: boolean;
    desktop: SanityObject<ImageProps>;
    mobile: SanityObject<ImageProps>;
};

export const LpBanner = Wrapper(
    ({ href, newTab, desktop, mobile }: LpBannerProps): JSX.Element | null => {
        const redirect = useLpRedirect();
        const linkProps = (function () {
            if (newTab) {
                return {
                    href,
                    rel: 'noopener noreferrer',
                    target: '_blank',
                };
            } else if (isAbsoluteUrl(href)) {
                return { href };
            }
            return { onClick: () => redirect(href) };
        })();

        return (
            <RawLpBanner
                linkProps={linkProps}
                desktop={<Image value={desktop} dataset="landing_page" />}
                mobile={
                    mobile ? (
                        <Image value={mobile} dataset="landing_page" />
                    ) : undefined
                }
            />
        );
    },
    'lpBanner'
);
